"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
export default function editorUploadField() {
  if (!window.fbControls) window.fbControls = new Array();
  window.fbControls.push(function(controlClass) {
    class controlAttachFile extends controlClass {
      static get definition() {
        return {
          icon: "\u{1F3DE}\uFE0F",
          i18n: {
            default: "Attach File",
            removeIconTitle: "Remove file"
          }
        };
      }
      configure() {
      }
      i18n(key) {
        return controlAttachFile.definition.i18n[key] || key;
      }
      /**
       * build a text DOM element, supporting other jquery text form-control's
       * @return DOM Element to be injected into the form.
       */
      build() {
        const _a = this.config, { value, userData } = _a, attrs = __objRest(_a, ["value", "userData"]);
        const currentValue = value || (userData ? userData[0] : "");
        const inputId = `${this.config.name}-input`;
        const fileControl = this.markup("input", null, __spreadProps(__spreadValues({}, attrs), {
          id: inputId,
          type: "file"
        }));
        if (!currentValue) {
          this.input = fileControl;
        } else {
          const removeButton = this.markup(
            "button",
            `<svg xmlns="http://www.w3.org/2000/svg" class="formBuilder__attachFile-icon" viewBox="0 0 512 512">
              <title>${this.i18n("removeIconTitle")}</title>
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="64" d="M368 368L144 144M368 144L144 368"/>
            </svg>
          `,
            {
              class: "formBuilder__attachFile-button",
              title: this.i18n("removeIconTitle"),
              alt: "remove"
            }
          );
          const hiddenInput = this.markup("input", currentValue, {
            id: inputId,
            type: "hidden",
            value: currentValue,
            name: this.config.name
          });
          const filename = currentValue.split("/").pop();
          const link = this.markup("a", filename, {
            href: currentValue,
            target: "_blank",
            class: "formBuilder__attachFile-preview"
          });
          const input = this.input = this.markup(
            "div",
            [link, hiddenInput, removeButton],
            { class: "formBuilder__attachFile" }
          );
          $(removeButton).on("click", function(evt) {
            evt.preventDefault();
            $(input).html(fileControl);
          });
        }
        return this.input;
      }
      onRender() {
        $("#" + this.config.name).html(this.config.value);
      }
    }
    controlClass.register("attachFile", controlAttachFile);
    return controlAttachFile;
  });
}
